import {
  ADMIN_ORG_FETCH_ALL,
  ADMIN_ORG_FETCH_ALL_SUCCESS,
  ADMIN_ORG_FETCH_ALL_FAIL,
  ADMIN_ORG_ADD,
  ADMIN_ORG_ADD_SUCCESS,
  ADMIN_ORG_ADD_FAIL,
  ADMIN_ORG_UPDATE,
  ADMIN_ORG_UPDATE_SUCCESS,
  ADMIN_ORG_UPDATE_FAIL,
  ADMIN_ORG_DELETE,
  ADMIN_ORG_DELETE_SUCCESS,
  ADMIN_ORG_DELETE_FAIL,
  ADMIN_ORG_SET_SORT,
  ADMIN_ORG_FETCH,
  ADMIN_ORG_FETCH_SUCCESS,
  ADMIN_ORG_FETCH_FAIL,
  ADMIN_ORG_ADD_USER,
  ADMIN_ORG_ADD_USER_SUCCESS,
  ADMIN_ORG_ADD_USER_FAIL,
  ADMIN_ORG_SET_PAGE,
  ADMIN_ORG_SET_PAGE_SIZE
} from './constants';

export const fetchOrgs = () => ({
  type: ADMIN_ORG_FETCH_ALL
});
export const fetchOrgsSuccess = orgs => ({
  type: ADMIN_ORG_FETCH_ALL_SUCCESS, orgs
});
export const fetchOrgsFail = error => ({
  type: ADMIN_ORG_FETCH_ALL_FAIL, error
});
export const fetchOrg = orgId => ({
  type: ADMIN_ORG_FETCH, orgId
});
export const fetchOrgSuccess = org => ({
  type: ADMIN_ORG_FETCH_SUCCESS, org
});
export const fetchOrgFail = error => ({
  type: ADMIN_ORG_FETCH_FAIL, error
});
export const addOrg = org => ({
  type: ADMIN_ORG_ADD, org
});
export const addOrgSucccess = org => ({
  type: ADMIN_ORG_ADD_SUCCESS, org
});
export const addOrgFail = error => ({
  type: ADMIN_ORG_ADD_FAIL, error
});
export const updateOrg = (org, cloudFilesToRemove = []) => ({
  type: ADMIN_ORG_UPDATE, org, cloudFilesToRemove
});
export const updateOrgSuccess = org => ({
  type: ADMIN_ORG_UPDATE_SUCCESS, org
});
export const updateOrgFail = (error, org) => ({
  type: ADMIN_ORG_UPDATE_FAIL, error, org
});
export const deleteOrg = (org, cloudFilesToRemove = []) => ({
  type: ADMIN_ORG_DELETE, org, cloudFilesToRemove
});
export const deleteOrgSuccess = () => ({
  type: ADMIN_ORG_DELETE_SUCCESS
});
export const deleteOrgFail = (error, org) => ({
  type: ADMIN_ORG_DELETE_FAIL, error, org
});
export const setAdminOrgSort = sort => ({
  type: ADMIN_ORG_SET_SORT, sort
});
export const addOrgUser = (email, orgId) => ({
  type: ADMIN_ORG_ADD_USER, email, orgId
});
export const addOrgUserSuccess = (user, orgId) => ({
  type: ADMIN_ORG_ADD_USER_SUCCESS, user, orgId
});
export const addOrgUserFail = (error) => ({
  type: ADMIN_ORG_ADD_USER_FAIL, error
});
export const setOrgPage = page => ({
  type: ADMIN_ORG_SET_PAGE, page
});
export const setOrgPageSize = size => ({
  type: ADMIN_ORG_SET_PAGE_SIZE, size
});
